
import axios from 'axios'
export default {
  components: {},
  props: [],
  name: 'home-page',
  data () {
    return {
      scrollTop: 0,
      valueName: null,
      tabId: 9999,
      aiHub: 1,
      channel: true,
      isGaotu: false // 线下 香港 海外  xianxia ri
    }
  },
  created () {
    this.setWXShareInfo()
    // if (this.$route.query && this.$route.query.aiHub) {
    //   this.aiHub = Number(this.$route.query.aiHub)
    // }
    // if (this.$route.query && (this.$route.query.channel && String(this.$route.query.channel) === 'true')) {
    //   this.channel = false
    // }
    this.isGaotu = this.$route.query && (this.$route.query.isGaotu * 1 === 1)
  },
  methods: {
    godetail (type) {
      this.$router.push({ path: '/detailPage', query: { level1: type } })
    },
    async querySure () {
      // 跳转
      this.getAllDataOnSearch()
    },
    goImg (type) {
      this.$router.push({ path: '/detail', query: { type: type } })
    },
    async getAllDataOnSearch () {
      // this.currentPage = 1
      // const args = {
      //   csName: this.valueName,
      //   page: this.currentPage,
      //   limit: 20,
      //   level1: this.tabId,
      //   level2: -1,
      //   typeIdList: [6, 32],
      //   isH5: true
      // }
      // const currentArgsStr = JSON.stringify(args)
      this.$router.push({ path: '/detailPage', query: { level1: this.tabId, csName: this.valueName, seach: true } })
      // this.$router.push({ path: '/detailPage', name: 'DetailPageNoLevel1', params: { homeArgs: args }, query: merge(this.$route.query, { myargs: currentArgsStr }) })
    },
    async setWXShareInfo () {
      const currentRouter = this.$router.currentRoute.fullPath
      const basehref = `https://domestic.gecacademy.cn${currentRouter}`
      const shareTitle = '全球华人导师科研'
      const shareDesc = 'Future Scholar\r\n学思砺新, 笃行致远'
      const shareImgUrl = 'https://gecacademy.oss-cn-beijing.aliyuncs.com/sou/%E9%9D%92%E6%A4%92-H5%E5%9B%BE%E6%A0%872.jpg'
      const shareInfo = {
        title: shareTitle,
        desc: shareDesc,
        link: basehref,
        imgUrl: shareImgUrl,
        success () { },
        cancel () { }
      }
      const test = Math.random()
      const timestamp = parseInt(new Date() / 1000)
      const params = {
        timestamp,
        noncestr: String(test),
        url: basehref,
        appName: 'domestic'
      }
      const result = await axios.post('https://gec-api.gecacademy.cn/souapi/wechat/sellTool/getSign', params)
      const signature = result.data.data.signature
      const wx = this.$wx
      await wx.configAsync({
        debug: false,
        appId: 'wxf88eda53c74e883f',
        timestamp,
        nonceStr: String(test),
        signature,
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'chooseImage',
          'previewImage',
          'uploadImage',
          'chooseWXPay'
        ]
      })
      wx.onMenuShareTimeline(shareInfo)
      wx.onMenuShareAppMessage(shareInfo)
      wx.updateAppMessageShareData(shareInfo)
      wx.updateTimelineShareData(shareInfo)
    }
  }
}
